import { MutableRefObject, useEffect } from 'react';

type UseOnClickOutsideProps = {
	ref: MutableRefObject<HTMLElement | null | undefined>;
	handler?: (event?: MouseEvent | TouchEvent) => void;
	enabled?: boolean;
};

export default function useOnClickOutside({
	ref,
	handler,
	enabled = true
}: UseOnClickOutsideProps): void {
	useEffect(() => {
		if (!enabled) return;

		const listener = (event: MouseEvent | TouchEvent) => {
			const target = event.target as HTMLElement;

			if (!ref?.current || ref?.current.contains(target)) {
				return;
			}

			if (handler) {
				handler(event);
			}
		};

		document.addEventListener('mousedown', listener);
		document.addEventListener('touchstart', listener);

		return () => {
			document.removeEventListener('mousedown', listener);
			document.removeEventListener('touchstart', listener);
		};
	}, [ref, handler, enabled]);
}
